import { inLifeQuotingFieldsData } from '@in-life/constants';
import { getInLifeQuotingFieldsData } from '@in-life/utils/getInLifeQuotingFieldsData';
import { enableButtonClickTracking } from '@snowplow/browser-plugin-button-click-tracking';
import { enableLinkClickTracking } from '@snowplow/browser-plugin-link-click-tracking';
import { SelfDescribingJson } from '@snowplow/tracker-core';
import snowplow from '@utilitywarehouse/tracking-adapter-snowplow-web';
import { FC, useEffect } from 'react';

import { SNOWPLOW_IN_LIFE_TRACKER_NAMESPACE } from '@constants/config';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';

const getInLifeQuotingFieldsSnowplowContext = (): SelfDescribingJson | null => {
  const entity = getInLifeQuotingFieldsData();
  if (
    !('snowplow' in entity) ||
    !entity.snowplow ||
    typeof entity.snowplow.schema !== 'string'
  ) {
    return null;
  }

  return {
    data: { ...entity.data } as Record<string, unknown>,
    schema: entity.snowplow.schema,
  };
};

const InLifeTracking: FC = () => {
  const { basketId } = useBasketContext();

  useEffect(() => {
    if (basketId && inLifeQuotingFieldsData.basket_id !== basketId) {
      inLifeQuotingFieldsData.basket_id = basketId;
    }
  }, [basketId]);

  useEffect(() => {
    snowplow.client?.core.setTrackerNamespace(
      SNOWPLOW_IN_LIFE_TRACKER_NAMESPACE || 'sp'
    );

    enableLinkClickTracking({
      pseudoClicks: true,
      context: [getInLifeQuotingFieldsSnowplowContext],
    });

    enableButtonClickTracking({
      context: [getInLifeQuotingFieldsSnowplowContext],
    });

    return () => {
      // reset to default tracker namespace when unmounted
      snowplow.client?.core.setTrackerNamespace('sp');
    };
  }, []);

  return <div data-testid="in-life-tracking" />;
};

export { InLifeTracking };
